export default __webpack_public_path__ + "static/media/z-index.31e0e8af.gif";